// extracted by mini-css-extract-plugin
export default {"reportItemButton":"reportItem_reportItemButton__soLIb"};